import styled from 'styled-components';

const RadarChartWrapper = styled.div`
  .chart-block {
    width: 500px;
    height: 500px;
    min-width: 200px;
    min-height: 200px;
  }

  .tab-pane-content {
    height: calc(100vh - 320px);
    overflow: auto;
  }

  .survey-text {
    width: 100%;
  }
`;

export default RadarChartWrapper;
